import { FC } from "react";
import {
  Box,
  createStyles,
  Link,
  makeStyles,
  Typography,
} from "@material-ui/core";

import {
  ACCOUNTING_AGREEMENT_URL,
  TERMS_AND_CONDITIONS_URL,
} from "../../constants";

const useStyles = makeStyles(() =>
  createStyles({
    link: {
      fontSize: 10,
    },
  }),
);

const TermsAndConditions: FC = () => {
  const classes = useStyles();

  return (
    <Typography component="div" variant="caption">
      <Box fontSize={10} textAlign="center" m={1}>
        By clicking below, you acknowledge that you are submitting a binding
        offer subject to our{" "}
        <Link
          className={classes.link}
          color="primary"
          variant="caption"
          href={TERMS_AND_CONDITIONS_URL}
          target="_blank"
          rel="noopener noreferrer"
          underline="always"
        >
          Terms of Use
        </Link>
        &nbsp;and&nbsp;
        <Link
          className={classes.link}
          color="primary"
          variant="caption"
          href={ACCOUNTING_AGREEMENT_URL}
          target="_blank"
          rel="noopener noreferrer"
          underline="always"
        >
          Accounting Agreement
        </Link>
        , and that you have read and agree to the terms.
      </Box>
    </Typography>
  );
};

export default TermsAndConditions;
